import useContractTemplate from "@extension/navbar/dynamicChildren/useContractTemplates"

const useGridControllerExtensions = (props) => {
    const contractTemplates = useContractTemplate(props);

    return  {
        contractTemplates
    }
}

export default useGridControllerExtensions
